(() => {
  'use strict';

  const dialog = document.querySelector('[data-bn-welcome-offer]');
  if (!dialog || typeof dialog.showModal !== 'function' || window.bnWelcomeOfferInitialized) return;
  window.bnWelcomeOfferInitialized = true;

  const sessionKey = 'bn_welcome_offer_seen_v2';
  const dismissalKey = 'bn_welcome_offer_dismissed_until_v2';
  const cooldown = 7 * 24 * 60 * 60 * 1000;
  const code = dialog.dataset.code;
  const reveal = dialog.querySelector('[data-bn-welcome-reveal]');
  const panel = dialog.querySelector('[data-bn-welcome-code-panel]');
  const input = dialog.querySelector('[data-bn-welcome-code]');
  const copy = dialog.querySelector('[data-bn-welcome-copy]');
  const status = dialog.querySelector('[data-bn-welcome-status]');
  if (!code || !reveal || !panel || !input || !copy || !status) return;

  let timer;
  let shown = false;
  let previousFocus;
  let pageActive = true;
  let dismissedHere = false;
  let deadline = Date.now() + 8000;

  const read = (storageName, key) => {
    try {
      return window[storageName].getItem(key);
    } catch {
      return null;
    }
  };

  const write = (storageName, key, value) => {
    try {
      window[storageName].setItem(key, value);
    } catch {
      return;
    }
  };

  const seenInBrowserSession = () => {
    try {
      return document.cookie.split(';').some((part) => part.trim() === `${sessionKey}=1`);
    } catch {
      return false;
    }
  };

  const markBrowserSession = () => {
    try {
      document.cookie = `${sessionKey}=1; Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
    } catch {
      return;
    }
  };

  const excludedPage = () => /\/(?:cart|checkout|checkouts|account)(?:\/|$)/i.test(window.location.pathname);
  const suppressed = () => shown || dismissedHere || seenInBrowserSession() || read('sessionStorage', sessionKey) === '1' || Number(read('localStorage', dismissalKey)) > Date.now();
  const clearTimer = () => {
    window.clearTimeout(timer);
    timer = undefined;
  };

  const otherDialogOpen = () => Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], [role="alertdialog"][aria-modal="true"]')).some((element) => element !== dialog && element.getClientRects().length > 0);

  const shouldDefer = () => {
    const active = document.activeElement;
    return document.visibilityState === 'hidden' || otherDialogOpen() || Boolean(active && (active.matches('input, textarea, select') || active.isContentEditable));
  };

  const attempt = () => {
    clearTimer();
    if (!pageActive || !dialog.isConnected || excludedPage() || suppressed()) return;
    if (Date.now() < deadline || shouldDefer()) {
      timer = window.setTimeout(attempt, Math.max(1000, deadline - Date.now()));
      return;
    }
    previousFocus = document.activeElement;
    try {
      dialog.showModal();
    } catch {
      return;
    }
    if (!dialog.open) return;
    shown = true;
    write('sessionStorage', sessionKey, '1');
    markBrowserSession();
  };

  const dismiss = () => {
    dismissedHere = true;
    write('localStorage', dismissalKey, String(Date.now() + cooldown));
    clearTimer();
    if (dialog.open) dialog.close();
  };

  dialog.querySelectorAll('[data-bn-welcome-dismiss]').forEach((button) => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    dismiss();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || !dialog.open) return;
    const focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element) => element.tabIndex >= 0 && element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]'));
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !dialog.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.addEventListener('close', () => {
    if (pageActive && previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  });
  reveal.addEventListener('click', () => {
    panel.hidden = false;
    reveal.setAttribute('aria-expanded', 'true');
    reveal.hidden = true;
    status.textContent = dialog.dataset.readyMessage;
    copy.focus({ preventScroll: true });
  });
  copy.addEventListener('click', async () => {
    try {
      if (!navigator.clipboard || !window.isSecureContext) throw new Error('manual_copy_required');
      await navigator.clipboard.writeText(code);
      status.textContent = dialog.dataset.copiedMessage;
    } catch {
      input.focus({ preventScroll: true });
      input.select();
      input.setSelectionRange(0, input.value.length);
      status.textContent = dialog.dataset.manualMessage;
    }
  });
  input.addEventListener('click', () => input.select());
  document.addEventListener('toggle', (event) => {
    if (dialog.open && event.target !== dialog && event.target instanceof HTMLDialogElement && event.target.open) dialog.close();
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && !shown && pageActive) attempt();
  });
  window.addEventListener('pagehide', () => {
    pageActive = false;
    clearTimer();
    if (dialog.open) dialog.close();
  });
  window.addEventListener('pageshow', (event) => {
    pageActive = true;
    if (event.persisted) deadline = Date.now() + 8000;
    if (!shown) attempt();
  });
  window.addEventListener('popstate', () => {
    if (excludedPage()) {
      clearTimer();
      if (dialog.open) dialog.close();
    } else if (!shown) {
      attempt();
    }
  });
  attempt();
})();
